<template>
  <div class="Loyalty-status">
    <ux-atoms-icon :name="iconName" class="Loyalty-status__icon" size="m" v-if="iconName" />
    <div class="Loyalty-status__text">
      <ux-atoms-typo :text="'Status'" as="p" color="light" variant="text-xsmall" />
      <ux-atoms-typo :text="statusLabel" as="p" color="dark" variant="text-medium" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { IconName } from '../../atoms/Icon/types';

export interface LoyaltyStatus {
  status: string;
}

const props = withDefaults(defineProps<LoyaltyStatus>(), {
  status: 'none'
});

const iconName = computed(() =>
  ['classic', 'diamond', 'gold', 'limitless', 'platinum', 'silver'].includes(props.status.toLowerCase())
    ? (`loyalty-${props.status.toLowerCase()}` as IconName)
    : null
);
const statusLabel = computed(() => props.status.toUpperCase());
</script>
<style lang="scss" scoped>
@use 'LoyaltyStatus.scss';
</style>
